// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SmtpModal-space1-_U4VW {
	margin-bottom: 6px !important;
}

.SmtpModal-space2-mEpAY {
	margin-bottom: 12px !important;
}

.SmtpModal-space3-oD6ck {
	margin-bottom: 18px !important;
}

.SmtpModal-space4-O2jbq {
	margin-bottom: 24px !important;
}

.SmtpModal-space5-GY3AB {
	margin-bottom: 30px !important;
}

.SmtpModal-space6-t4b64 {
	margin-bottom: 36px !important;
}

.SmtpModal-space7-esRwe {
	margin-bottom: 42px !important;
}

.SmtpModal-space8-Nhjq8 {
	margin-bottom: 48px !important;
}

.SmtpModal-spaceTop1-L2_Fr {
	margin-top: 6px !important;
}

.SmtpModal-spaceTop2-JCVbh {
	margin-top: 12px !important;
}

.SmtpModal-spaceTop3-yE35E {
	margin-top: 18px !important;
}

.SmtpModal-spaceTop4-HKzIV {
	margin-top: 24px !important;
}

.SmtpModal-spaceTop5-Y2YYp {
	margin-top: 30px !important;
}

.SmtpModal-spaceTop6-VozTE {
	margin-top: 36px !important;
}

.SmtpModal-spaceTop7-pTJPD {
	margin-top: 42px !important;
}

.SmtpModal-spaceTop8-aFUl0 {
	margin-top: 48px !important;
}

.SmtpModal-noMargin-tEyeP {
	margin: 0px !important;
}

.SmtpModal-padding1-_PUfD {
	padding-bottom: 6px !important;
}

.SmtpModal-padding2-ReFXJ {
	padding-bottom: 12px !important;
}

.SmtpModal-padding3-ga00l {
	padding-bottom: 18px !important;
}

.SmtpModal-padding4-uBf7j {
	padding-bottom: 24px !important;
}

.SmtpModal-padding5-oLUvj {
	padding-bottom: 30px !important;
}

.SmtpModal-padding6-ZM_YZ {
	padding-bottom: 36px !important;
}

.SmtpModal-padding7-RxwBj {
	padding-bottom: 42px !important;
}

.SmtpModal-paddingTop1-AwcuY {
	padding-top: 6px !important;
}

.SmtpModal-paddingTop2-rP6X4 {
	padding-top: 12px !important;
}

.SmtpModal-paddingTop3-jRqGK {
	padding-top: 18px !important;
}

.SmtpModal-paddingTop4-VJlaf {
	padding-top: 24px !important;
}

.SmtpModal-paddingTop5-DbCDT {
	padding-top: 30px !important;
}

.SmtpModal-paddingTop6-_lo3u {
	padding-top: 36px !important;
}

.SmtpModal-paddingTop7-SBAC8 {
	padding-top: 42px !important;
}

.SmtpModal-noPadding-ExflY {
	padding: 0px !important;
}

.SmtpModal-spaceMarginBottom0-HudDW {
	margin-bottom: 0;
}

.SmtpModal-textBold-QFLsG {
	font-weight: 500 !important;
}

.SmtpModal-textBolder-I8dfu {
	font-weight: 700 !important;
}

.SmtpModal-textNormal-K6PRO {
	font-weight: normal !important;
}

/*New Design Text Colors */

.SmtpModal-textDarkBlue-ghJRT {
	color: rgb(20, 39, 94) !important;
}

.SmtpModal-textLightBlue-XbY0i {
	color: rgb(57, 87, 106) !important;
}

.SmtpModal-textLightSandleGreen-kr7XS {
	color: rgb(76, 86, 41) !important;
}

.SmtpModal-textLightBrown-iE4xF {
	color: rgb(115, 79, 33) !important;
}

.SmtpModal-textMediumMaroon-PTwDU {
	color: rgb(87, 37, 51) !important;
}

.SmtpModal-textBrown-FC3ch {
	color: rgb(160, 47, 24) !important;
}

.SmtpModal-textMaroon-ABW_Z {
	color: rgb(155, 49, 67) !important;
}

.SmtpModal-textDarkBrown-k7IY0 {
	color: rgb(83, 18, 16) !important;
}

.SmtpModal-textMediumBrown-F8xFY {
	color: rgb(142, 28, 10) !important;
}

.SmtpModal-textSkyBlue-jcOqX {
	color: rgb(37, 117, 141) !important;
}

.SmtpModal-textGray-BAsSh {
	color: rgb(77, 65, 51) !important;
}

.SmtpModal-errorMessage-cRgBG {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.SmtpModal-userText-VwJmt {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.SmtpModal-panelHeader-QZcNX {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.SmtpModal-exportSection-loEy9 {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.SmtpModal-exportSectionGridSub-vgITj {
	grid-template-columns: 50% 49% !important;
}

.SmtpModal-exportText-hcBgU {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.SmtpModal-exportLinkImg-G0vJZ {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.SmtpModal-exportImg-V2MGi {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.SmtpModal-linkBtn-SLcJv {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.SmtpModal-table-Huo4b {
	display: table;
}

.SmtpModal-tableRow-I5L9s {
	display: table-row;
}

.SmtpModal-tableCell-effDW {
	display: table-cell;
	float: none;
}

.SmtpModal-formGroup-gpHOM {
	margin-bottom: 6px;
}

.SmtpModal-marginTop0-_f44o {
	margin-top: 0;
}

.SmtpModal-marginBottom20-_K48i {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.SmtpModal-bannerImageBg-qYJ8g {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.SmtpModal-bannerDelete-SO5LD {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.SmtpModal-exportLink-Fb0r8 {
	padding-top: 10px;
	padding-right: 10px;
}

.SmtpModal-seachContent-FVMwa {
	padding-left: 0px;
	margin-bottom: 5px;
}

.SmtpModal-marginBottom9-Lm7PX {
	margin-bottom: 9px;
}

.SmtpModal-spaceTop52-qgT5y {
	margin-top: 52px;
}

.SmtpModal-profileViewInner-tUZTP {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.SmtpModal-profileViewMain-gNV1y {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.SmtpModal-profileViewlabel-B5Npl {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.SmtpModal-profileViewMainContent-BcBvV {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.SmtpModal-reviewsFormStar-UsSSZ {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.SmtpModal-reviewsFormStar-UsSSZ svg {
	cursor: pointer;
}

.SmtpModal-addLanguageText-Q35Ik {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.SmtpModal-exportSection-loEy9 {
		grid-template-columns: 100%;
	}

	.SmtpModal-spaceTop52-qgT5y {
		margin-top: 18px;
	}

	.SmtpModal-exportText-hcBgU {
		float: none;
		margin-top: 12px;
	}

	.SmtpModal-exportSectionGridSub-vgITj {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.SmtpModal-profileViewlabel-B5Npl {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.SmtpModal-profileViewMainContent-BcBvV {
		width: 100%;
		text-align: center;
	}

	.SmtpModal-panelHeader-QZcNX {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/

.SmtpModal-buttonFlexContainer-alSe0{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: end;
        -ms-flex-pack: end;
            justify-content: flex-end;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    gap: 15px;
    margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/siteadmin/SmtpManagement/SmtpModal/SmtpModal.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E;;ACvN3E;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,qBAAyB;QAAzB,kBAAyB;YAAzB,yBAAyB;IACzB,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,mBAAe;QAAf,eAAe;IACf,SAAS;IACT,gBAAgB;AACpB","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/","@import '../../admin-common.css';\n.buttonFlexContainer{\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 15px;\n    margin-top: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `SmtpModal-space1-_U4VW`,
	"space2": `SmtpModal-space2-mEpAY`,
	"space3": `SmtpModal-space3-oD6ck`,
	"space4": `SmtpModal-space4-O2jbq`,
	"space5": `SmtpModal-space5-GY3AB`,
	"space6": `SmtpModal-space6-t4b64`,
	"space7": `SmtpModal-space7-esRwe`,
	"space8": `SmtpModal-space8-Nhjq8`,
	"spaceTop1": `SmtpModal-spaceTop1-L2_Fr`,
	"spaceTop2": `SmtpModal-spaceTop2-JCVbh`,
	"spaceTop3": `SmtpModal-spaceTop3-yE35E`,
	"spaceTop4": `SmtpModal-spaceTop4-HKzIV`,
	"spaceTop5": `SmtpModal-spaceTop5-Y2YYp`,
	"spaceTop6": `SmtpModal-spaceTop6-VozTE`,
	"spaceTop7": `SmtpModal-spaceTop7-pTJPD`,
	"spaceTop8": `SmtpModal-spaceTop8-aFUl0`,
	"noMargin": `SmtpModal-noMargin-tEyeP`,
	"padding1": `SmtpModal-padding1-_PUfD`,
	"padding2": `SmtpModal-padding2-ReFXJ`,
	"padding3": `SmtpModal-padding3-ga00l`,
	"padding4": `SmtpModal-padding4-uBf7j`,
	"padding5": `SmtpModal-padding5-oLUvj`,
	"padding6": `SmtpModal-padding6-ZM_YZ`,
	"padding7": `SmtpModal-padding7-RxwBj`,
	"paddingTop1": `SmtpModal-paddingTop1-AwcuY`,
	"paddingTop2": `SmtpModal-paddingTop2-rP6X4`,
	"paddingTop3": `SmtpModal-paddingTop3-jRqGK`,
	"paddingTop4": `SmtpModal-paddingTop4-VJlaf`,
	"paddingTop5": `SmtpModal-paddingTop5-DbCDT`,
	"paddingTop6": `SmtpModal-paddingTop6-_lo3u`,
	"paddingTop7": `SmtpModal-paddingTop7-SBAC8`,
	"noPadding": `SmtpModal-noPadding-ExflY`,
	"spaceMarginBottom0": `SmtpModal-spaceMarginBottom0-HudDW`,
	"textBold": `SmtpModal-textBold-QFLsG`,
	"textBolder": `SmtpModal-textBolder-I8dfu`,
	"textNormal": `SmtpModal-textNormal-K6PRO`,
	"textDarkBlue": `SmtpModal-textDarkBlue-ghJRT`,
	"textLightBlue": `SmtpModal-textLightBlue-XbY0i`,
	"textLightSandleGreen": `SmtpModal-textLightSandleGreen-kr7XS`,
	"textLightBrown": `SmtpModal-textLightBrown-iE4xF`,
	"textMediumMaroon": `SmtpModal-textMediumMaroon-PTwDU`,
	"textBrown": `SmtpModal-textBrown-FC3ch`,
	"textMaroon": `SmtpModal-textMaroon-ABW_Z`,
	"textDarkBrown": `SmtpModal-textDarkBrown-k7IY0`,
	"textMediumBrown": `SmtpModal-textMediumBrown-F8xFY`,
	"textSkyBlue": `SmtpModal-textSkyBlue-jcOqX`,
	"textGray": `SmtpModal-textGray-BAsSh`,
	"errorMessage": `SmtpModal-errorMessage-cRgBG`,
	"userText": `SmtpModal-userText-VwJmt`,
	"panelHeader": `SmtpModal-panelHeader-QZcNX`,
	"exportSection": `SmtpModal-exportSection-loEy9`,
	"exportSectionGridSub": `SmtpModal-exportSectionGridSub-vgITj`,
	"exportText": `SmtpModal-exportText-hcBgU`,
	"exportLinkImg": `SmtpModal-exportLinkImg-G0vJZ`,
	"exportImg": `SmtpModal-exportImg-V2MGi`,
	"linkBtn": `SmtpModal-linkBtn-SLcJv`,
	"table": `SmtpModal-table-Huo4b`,
	"tableRow": `SmtpModal-tableRow-I5L9s`,
	"tableCell": `SmtpModal-tableCell-effDW`,
	"formGroup": `SmtpModal-formGroup-gpHOM`,
	"marginTop0": `SmtpModal-marginTop0-_f44o`,
	"marginBottom20": `SmtpModal-marginBottom20-_K48i`,
	"bannerImageBg": `SmtpModal-bannerImageBg-qYJ8g`,
	"bannerDelete": `SmtpModal-bannerDelete-SO5LD`,
	"exportLink": `SmtpModal-exportLink-Fb0r8`,
	"seachContent": `SmtpModal-seachContent-FVMwa`,
	"marginBottom9": `SmtpModal-marginBottom9-Lm7PX`,
	"spaceTop52": `SmtpModal-spaceTop52-qgT5y`,
	"profileViewInner": `SmtpModal-profileViewInner-tUZTP`,
	"profileViewMain": `SmtpModal-profileViewMain-gNV1y`,
	"profileViewlabel": `SmtpModal-profileViewlabel-B5Npl`,
	"profileViewMainContent": `SmtpModal-profileViewMainContent-BcBvV`,
	"reviewsFormStar": `SmtpModal-reviewsFormStar-UsSSZ`,
	"addLanguageText": `SmtpModal-addLanguageText-Q35Ik`,
	"buttonFlexContainer": `SmtpModal-buttonFlexContainer-alSe0`
};
module.exports = ___CSS_LOADER_EXPORT___;
